import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ActiveDirectoryService } from 'src/app/private/services/activedirectoryconfig.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-active-directory',
  imports: [SharedModule],
  templateUrl: './create-active-directory.component.html',
  styleUrl: './create-active-directory.component.scss'
})
export class CreateActiveDirectoryComponent {
  @Input() type: 'Create' | 'Update' = 'Create';
  @Input() activeDirectoryDataToEdit: any = null;
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  @Input() clientId!: string;

  outlookForm: FormGroup;
  isLoading = false;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private activeDirectoryService: ActiveDirectoryService,
    private messageService: MessageService

  ) {
    this.outlookForm = this.fb.group({
      app_client_id: ['', Validators.required],
      client_secret: ['', Validators.required],
      grant_type: ['client_credentials', Validators.required],
      tenant_id: ['', Validators.required],
      scope: ['https://graph.microsoft.com/.default', Validators.required],
      redirect_uri: ['', Validators.required]
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.activeDirectoryDataToEdit) {
      this.outlookForm.patchValue(this.activeDirectoryDataToEdit);
    }
  }

  handleCloseDialog() {
    this.close.emit();
  }

  submitForm() {
    this.submitted = true;
    if (this.outlookForm.invalid) {
      this.outlookForm.markAllAsTouched();
      return;
    }

    const payload = { ...this.outlookForm.value };
    payload['client_id'] = this.clientId; // Ensure client_id is set from input

    this.isLoading = true;

    if (this.type === 'Update') {
      payload['id'] = this.activeDirectoryDataToEdit.id;
      this.activeDirectoryService.updateActiveDirectoryConfig(payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Configuration updated successfully!' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err || 'Update failed!' });
        },
        complete: () => this.isLoading = false
      });
    } else {
      this.activeDirectoryService.createActiveDirectoryConfig(payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Configuration created successfully!' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err || 'Create failed!' });
        },
        complete: () => this.isLoading = false
      });
    }
  }
}
